<template>
<div>
   <section>
    <div class="hero">
        <div class="hero-content">
            <div class="foto-text">
                <p>Hannah Clausen, medical student, for One Dear Thing.</p>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="overlapping-product-image desktop-only"></div>
</section>
<section>
    <div class="presentation-wrapper">
        <div class="presentation-text">
            <div class="hero-text">
                <h1>Embrace the <span class="nobreak">Exquisite.</span></h1>
            </div>
            <p>We offer one sustainably produced product at a time.</p>
            <p>One Dear Thing #1 is a bed set in organic cotton satin,  printed in a pattern inspired by Doctors Without Borders  and sold for their beneﬁt.</p>
        </div>
        <div class="image-wrapper mobile-only">
            <div class="product-image"></div>
        </div>
        <div class="button-wrapper">
             <button v-on:click="toShop" class="button-dark"> To Shop </button>
        </div>
    </div>
    <div class="stripe"></div>
</section>
</div>

</template>

<script>
export default {
    name: "shop-hero",
    methods: {
        toShop() {
            this.$router.push("/Shop");
        }
    }
}
</script>
  
<style lang="postcss" scoped>
    .stripe {
        border-bottom: 1px solid #5554545d;
        width: 66.66%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 3%;
    }
    .foto-text {
        width: 100%;
        margin-top: 660px;
        color: white;
        display: flex;
        font-family: Didot-Italic;
        justify-content: flex-end;
    }
    .foto-text p {padding-right: 10px;}
    .hero {
        width: 100%;
        height: 700px;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        background-image: url("https://queenslabcdn.blob.core.windows.net/odt/hero-20181119.jpg"); 
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .hero-content {
        flex-grow: 1;
        height: 100%;
        width: 100%;
    }
  
    .hero-text {
        text-align: center;
        margin-top: 7%;
        color: rgba(0, 0, 0, 0.85);
        font-size: 1.2em;
        font-family: Didot-Italic;
    }

    .hero-text h1 {
        font-size: 2em;
    }
    
    .hero-button {
        display: flex;
        height: 80px;
        padding-right: 10%;
      
    }
    .overlapping-product-image {
        position: absolute;
        z-index: 500;
        margin-top: -200px;
        margin-left: 20px;
        width: 420px;
        height: 300px;
        background-image: url("https://queenslabcdn.blob.core.windows.net/odt/img/bed-set-transparent.png"); 
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .presentation-wrapper {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 5%;

    }
    .presentation-text {
        width: 30%;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
    }
    .button-wrapper {
        width: 100%;
        padding-top: 3%;
        display: flex;
        justify-content: center;

    }
    button {
        width: 200px;
        margin-left: auto; 
        margin-right:auto; 
        display: flex;
        justify-content: center;
    }

 
   @media screen and (max-width: 780px) {
   .foto-text p {display: none;}
    .hero-text {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
        padding-top: 6%;
        padding-bottom: 6%;
        margin-bottom: 16px;
    }
    .hero-text h1 {
        line-height: 1.2em;
        font-size: 1.6em;
    }
    .overlappingImage { 
        position: relative;
        height: 200px; 
        width: 350px; 
        margin-top: 10%;
    }
      
    .presentation-text {
        width: 70%;
    }

    .button-wrapper {
        width: 100%;
        padding-top: 10%;
        padding-bottom: 10%;
    }
    .product-image {
        display: flex;
        width: 320px;
        height: 200px;
        background-image: url("https://queenslabcdn.blob.core.windows.net/odt/img/bed-set-transparent.png"); 
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;

    }

    .image-wrapper {
        margin-top: 10%;
        margin-bottom: 5%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

 
}
  </style>